// extracted by mini-css-extract-plugin
export default {"header":"WaterStructure_header__GhVnl","content":"WaterStructure_content__iKdc5","divider":"WaterStructure_divider__ikQbD"};